import { IApi } from '@/setup/api-client'
import { useApiMutation } from '@/utils/api/api-mutation'
import { useApiToolbox } from '@/utils/api/use-api-toolbox'
import { GetMembersQuery } from '@/api/organization/members/get-members-query'
import { GetMembersPolicyQuery } from '@/api/organization/members/get-members-policy-query'

interface IRemoveMemberArgs {
    organizationId: string
    userId: string
}

export class RemoveMemberMutation {
    static async call(api: IApi, args: IRemoveMemberArgs) {
        return api.delete(`/organization/${args.organizationId}/members/${args.userId}`).then((res) => res.data)
    }
}

export function useRemoveMemberMutation() {
    const { api, apiParams, qc } = useApiToolbox()

    return useApiMutation<unknown, { userId: string }>({
        mutationFn: ({ userId }) =>
            RemoveMemberMutation.call(api, {
                organizationId: apiParams.organizationId,
                userId,
            }),
        onSuccess: () => {
            qc.invalidateQueries({
                queryKey: GetMembersQuery.getKey({ organizationId: apiParams.organizationId }),
            })
            qc.invalidateQueries({
                queryKey: GetMembersPolicyQuery.getKey({ organizationId: apiParams.organizationId }),
            })
        },
    })
}
